import React from 'react';
import history from '../../history';
import { LoadingScreen } from '../../containers/LoadingScreen/LoadingScreen';

export const OIDCError = () => {
  history.replace(`/`, '_self');

  return <LoadingScreen handleOidcError />;
};



// WEBPACK FOOTER //
// ./src/containers/OIDC/OIDCError.jsx